import { Journey } from "@/types/*";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface EmergencyContact {
    name: string;
    phoneNumber: string;
    selectCountry: string;
    relationship: string;
}

export interface CheckInState {
    segmentKey : string | null;
    currentBookingInStateContext: any[] | null;
    selectedJourneys: any[];
    selectedPassengerSegments: any[] | null;
    selectedPassengers: any[] | null;
    selectedPassengersTripTwo: any[] | null;
    emergencyContactDetails: EmergencyContact[] | null;
    orgAndDst: any[] | null;
    data: any[];
    activeCard: number;
    passengerInfo: any[];
    isAutoAssign: boolean;
    primaryContact: any | null;
}

const initialStateCheckInData: CheckInState = {
    segmentKey: null,
    currentBookingInStateContext: null,
    selectedJourneys: [],
    selectedPassengerSegments: null,
    selectedPassengers: null,
    selectedPassengersTripTwo: null,
    emergencyContactDetails: null,
    orgAndDst: null,
    data: [],
    activeCard: 0,
    passengerInfo: [],
    isAutoAssign: false,
    primaryContact: null
};

export const checkInSlice = createSlice({
    name : "checkIn",
    initialState: initialStateCheckInData,
    reducers:{
        resetState: (state) => {
            state.selectedPassengers = null; // or initial value
            state.selectedPassengersTripTwo = null; // or initial value
        },
        setSegmentKey: (state, action: PayloadAction<string>) => {
            state.segmentKey = action.payload;
        },
        setCurrentBookingInStateContext: (state, action: PayloadAction<any[]>) =>{
            state.currentBookingInStateContext = action.payload;
        },
        setSelectedJourneys: (state, action: PayloadAction<Journey[]>) =>{
            state.selectedJourneys = action.payload;
        },
        setSelectedPassengerSegments: (state, action: PayloadAction<any[]>) =>{
            state.selectedPassengerSegments = action.payload;
        },
        setSelectedPassengers: (state, action: PayloadAction<any[]>) =>{
            state.selectedPassengers = action.payload;
        },
        setSelectedPassengersTripTwo: (state, action: PayloadAction<any[]>) =>{
            state.selectedPassengersTripTwo = action.payload;
        },
        setEmergencyContactDetails: (state, action: PayloadAction<EmergencyContact[]>) =>{
            state.emergencyContactDetails = action.payload;
        },
        setOrgAndDst: (state, action: PayloadAction<any[]>) =>{
            state.orgAndDst = action.payload;
        },
        setData: (state, action: PayloadAction<string[]>) =>{
            state.data = action.payload;
        },
        setActiveCard: (state, action: PayloadAction<number>) =>{
            state.activeCard = action.payload;
        },
        setPassengerInfo: (state, action: PayloadAction<any[]>) =>{
            state.passengerInfo = action.payload;
        },
        setIsAutoAssign: (state, action: PayloadAction<boolean>)=>{
            state.isAutoAssign = action.payload;   
        },
        setPrimaryContact: (state, action: PayloadAction<any>)=>{
            state.primaryContact = action.payload;   
        }
    },
});

export const {
    setSegmentKey,
    setCurrentBookingInStateContext,
    setSelectedJourneys,
    setSelectedPassengerSegments,
    setSelectedPassengers,
    setSelectedPassengersTripTwo,
    setActiveCard,
    setData,
    setEmergencyContactDetails,
    setIsAutoAssign,
    setOrgAndDst,
    setPassengerInfo,
    setPrimaryContact,
    resetState
} = checkInSlice.actions;

export default checkInSlice.reducer;